<template>
  <div class="wrapper-offers">
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>AcyMailing - <span class="text--primary">20% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/acymailing.png"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>AcyMailing is the n°1 emailing plugin for Joomla and WordPress.<br/>
            With more than 10 years in development and emailing AcyMailing allows almost everybody to handle his email communication easily.<br/>
            Create template, send newsletters, check the stats. Using AcyMailing you will all the tools you need to improve your marketing and grow your audience. </p>
          <p><a href="https://www.acymailing.com/">AcyMailing Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.acymailing")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Akeeba Backup Pro - <span class="text--primary">30% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/akeeba-logo.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>Akeeba Backup is the most widely used open-source backup component for the Joomla! CMS.
            Its mission is simple: create a site backup that can be restored on any Joomla!-capable server, making it ideal not only for backups but also for site transfers or even deploying sites to your clients' servers.
            Akeeba Backup creates a full backup of your site in a single archive. </p>
          <p><a href="https://www.akeebabackup.com/">Akeeba Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.akeeba")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Digital Peaks - <span class="text--primary">25% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/dp.png"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>Digital Peak is a long term Joomla extension software company from Switzerland. Our seamless integrated extensions do give some extra love to your web site. If you are looking for a full featured event management extension, case management tool or Google analytics integration, then we are here for you. Always pushing the boundaries forward is what motivates us everyday. As Joomla core developers and maintainers we know what we are talking about. So let's get connected!</p>
          <p><a href="https://joomla.digital-peak.com">Digital Peaks Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.dpcalendar")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>miTT PWA - <span class="text--primary">20% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/mittpwa.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>miTT PWA is one of the leading PWA solutions created by Robert Mittl. As a Joomla developer, he specializes in PWA, web APIs and app solutions.</p>
          <p>The extension allows transforming a Joomla website into an app. The PWA is installable on Mobile Phones and Desktops. It gives more control over cache, offline availability, push notifications, background synchronization and much more.
          </p>
          <p>miTT PWA comes in 3 versions:</p>
          <ul>
            <li>miTT PWA</li>
            <li>miTT PWA FIRE PUSH (Push Notifications based on Firebase)</li>
            <li>miTT PWA ONE PUSH (Push Notifications based on OneSignal)</li>
          </ul>
          <p>Let me know if you have any questions about how to appify your Joomla.</p>
          <p><a href="https://mittl-medien.de/product-pwa">miTT PWA Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.mittpwa")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>J!Training - <span class="text--primary">20% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/jtraining_logo_rgb.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>
            J!Training is a qualified provider of training courses for certification as a Joomla! administrator in the German speaking countries. Become an expert with us and climb the Joomla! summit. Whether beginner or advanced - we always offer the right training.
            Get your knowledge certified and present yourself to your customers as a Joomla! expert. Become an official Joomla! administrator with us!
          </p>
          <p><a href="https://www.jtraining.de/">J!Training Website</a></p>
          <label>Coupon Code (Add as note to Booking)</label>
          <pre>{{$t("toolbox.coupons.jtraining")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Kicktemp - <span class="text--primary">25% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/kicktemp_horiz.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>Kicktemp is a young extension-developement-studio from Hamburg, Germany. Behind the still young company, however, many years of Joomla experience are gathered (starting back in Mambo times). Beside the probably best known extension from the house: KickGDPR, Kicktemp offers a variety of extensions and expertise as a YOOtheme expert.</p>
          <p><a href="https://www.kicktemp.com/">Kicktemp Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.kicktemp")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>PWT Extensions - <span class="text--primary">25% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/PWT-Extensions.png"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>PWT Extensions - Our powerful and user-friendly Joomla! extensions made by a team of Joomla! experts:</p>
          <ul>
            <li><strong>PWT ACL:</strong> Joomla ACL made easy, formerly known as ACL Manager. Setup, manage & fix ACL permissions.</li>
            <li><strong>PWT SEO:</strong> Set a keyword & start improving the SEO value of any page of your Joomla site via clear hints.</li>
            <li><strong>PWT Image:</strong> Easily crop & resize images following the width and ratio settings. Get rid of external image tools!</li>
            <li><strong>PWT Sitemap:</strong> Set up your sitemap for visitors and search engines within minutes, using menu-items.</li>
          </ul>
          <p><a href="https://extensions.perfectwebteam.com/">PWT Extensions Website</a></p>
          <label>Get your Discount: 25% discount via <a href="https://extensions.perfectwebteam.com/BackupMonkey">https://extensions.perfectwebteam.com/BackupMonkey</a></label>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>RSFirewall! - <span class="text--primary">30% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/logo-rsfirewall.png"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>RSFirewall! is the most advanced Joomla! security service that you can use to protect your Joomla! website from intrusions and hacker attacks. RSFirewall! is backed up by a team of experts that are trained to be always up to date with the latest known vulnerabilities and security updates.</p>
          <p>Highlights:<br/>
          <ul>
          <li>Protect your website from Joomla! RCE vulnerabilities</li>
            <li>Scan your files for malware</li>
            <li>Protect your /administrator folder with an extra password</li>
            <li>Check Joomla! core files for integrity</li>
            <li>Protect administrator accounts</li>
            <li>Steps to increase your website's security</li>
            <li>Find and fix insecure file and folder permissions</li>
            <li>Block access to specific countries</li>
            <li>Automatically block IPs that attack your website</li>
          </ul>
          <p><a href="https://www.rsjoomla.com/joomla-extensions/joomla-security.html">RSFirewall! Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.rsfirewall")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <h2>RSForm!Pro - <span class="text--primary">30% Discount</span></h2>
    </b-row>
    <hr/>
    <b-row>
      <b-col class="mb-2" cols="6" md="4" lg="3">
        <img class="w-100" src="/images/offers/logos/logo-rsformpro.png"/>
      </b-col>
      <b-col md="8" lg="9">
        <p>RSForm!Pro is a must have for all web developers. With the full set of features available you can easily create the most elaborate forms for your website, starting from simple contact forms to advanced multi-page forms with dynamic content.</p>
        <p>Highlights:<br/>
        <ul>
          <li>Multiple layouts: Responsive, Bootstrap 2, 3 and 4, UIkit 2 and 3, Zurb Foundation</li>
          <li>Drag and drop grid</li>
          <li>Multi-language support</li>
          <li>Create forms with conditional fields</li>
          <li>Unlimited emails can be configured</li>
          <li>Map submissions to another database</li>
          <li>Simple and flexible component for calculation forms</li>
          <li>Pop-up calendar with time selection</li>
          <li>CAPTCHA and reCAPTCHA support (including reCAPTCHA v3)</li>
        </ul>
        <p><a href="https://www.rsjoomla.com/joomla-extensions/joomla-form.html">RSForm! Website</a></p>
        <label>Coupon Code</label>
        <pre>{{$t("toolbox.coupons.rsform")}}</pre>
      </b-col>
    </b-row>
  </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>Techjoomla - <span class="text--primary">15% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/techjoomla.png"/>
        </b-col>
        <b-col md="8" lg="9">
          <p>Powerful Joomla Extensions for Events, ELearning, Advertising, Donations & much more. </p>
          <ul>
            <li><strong>Shika:</strong> Full Fledged Learning Management system for Joomla that packs a punch.</li>
            <li><strong>JGive:</strong> Powerful Donations & Crowdfunding system for Joomla!</li>
            <li><strong>JTicketing:</strong> A feature packed ticketing system with a native event manager and integration for Jomsocial Events and JEvents  </li>
            <li><strong>SocialAds:</strong> Powerful Advertising Solution for Joomla with Multiple Ad Types, Targeting Options & Analytics</li>
          </ul>
          <p>Check out all our extensions at the <a href="https://techjoomla.com/">Techjoomla Website</a></p>
          <label>Coupon Code</label>
          <pre>{{$t("toolbox.coupons.techjoomla")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>EasyContracts - <span class="text--primary">25% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/easycontracts.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p><strong>The service is only available in German</strong></p>
          <p>Verträge und AGB speziell für Webdesigner und Agenturen. Von Dr.
            Ronald Kandelhard, Fachanwalt für Handels- und Gesellschaftsrecht, mit
            erfahrenen Praktikern im Webdesign entwickelt. </p>
          <p>Vermeide Abmahnungen, Bußgelder und Schadensersatzforderungen und gestalte dein Business professioneller und sicher.</p>
          <p><a href="https://easycontracts.de/">EasyContracts Website</a></p>
          <label>Coupon Code (gültig für folgende Produkte: <a href="https://easycontracts.de/vertraege/webservice/vertrag-wartung/">Wartungsvertrag</a>, <a href="https://easycontracts.de/vertraege/webservice/vertrag-wartung-hosting/">Wartungsvertrag & Hosting</a>, <a href="https://easycontracts.de/vertraege/webservice/webdesign-vertrag/">Webdesign</a>)</label>
          <pre>{{$t("toolbox.coupons.easycontracts")}}</pre>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2>EasyRechtssicher - <span class="text--primary">25% Discount</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="mb-2" cols="6" md="4" lg="3">
          <img class="w-100" src="/images/offers/logos/easyrechtssicher.svg"/>
        </b-col>
        <b-col md="8" lg="9">
          <p><strong>The service is only available in German</strong></p>
          <p>Vermeide Deine Haftung und verdiene daran! Als Webdesigner oder
            Agentur bist Du praktisch immer in der Haftung, wenn die von Dir
            erstellte Website nicht rechtssicher ist. Lass lieber Recht unsere
            Sorge sein. Mit easyRechtssicher kannst Du Datenschutzerklärung
            und Impressum sowie weitere Muster bequem im Generator erstellen,
            Deine Kundenwebsites bequem in unserem Backend als Projekt
            verwalten und im Wartungsvertrag abrechnen. </p>
          <p>Und das Beste dabei ist: Wir halten die Muster automatisch aktuell,
            wenn sich rechtlich etwas ändert. Dadurch hast Du keinen
            Aufwand. </p>
          <p><a href="https://easyrechtssicher.de/">easyRechtssicher Website</a></p>
          <label>Coupon Code (gültig für die <a href="https://easyrechtssicher.de/produkte/mitgliedschaft-webdesigner-agenturen-2/">Agenturlizenz</a>)</label>
          <pre>{{$t("toolbox.coupons.easyrechtssicher")}}</pre>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Offers',
  methods: {
    ...mapMutations([
      'setViewname'
    ])
  }
}
</script>
